import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobile } from 'utils/miscUtil';

function EmailRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const assignmentIdHandler = loc => {
    const searchParameter = loc?.search;
    if (!searchParameter || !searchParameter.includes('assignmentId'))
      return null;
    const assignmentSearchParameter = /assignmentId=(.*)/gm.exec(
      searchParameter,
    ) || [null];
    // eslint-disable-next-line prefer-destructuring
    return assignmentSearchParameter[1];
  };
  const redirectToDependOnDevice = assignmentId => {
    if (isMobile.Android()) {
      window.location.href = `tfv://tolk.tolkformedlingvast.se/email-redirect?assignmentId=${assignmentId}`;

      setTimeout(() => {
        window.location.replace(
          'https://play.google.com/store/apps/details?id=se.tolkformedlingvast.tolkapp',
        );
      }, 10000);
      return;
    }
    if (isMobile.iOS()) {
      window.location.replace(
        `tfv://tolk.tolkformedlingvast.se/email-redirect?assignmentId=${assignmentId}`,
      );

      setTimeout(() => {
        window.location.replace(
          'https://apps.apple.com/us/app/itunes-connect/id376771144',
        );
      }, 10000);
    }
  };
  const redirectToPath = assignmentId => {
    if (isMobile.any()) {
      redirectToDependOnDevice(assignmentId);
      return;
    }
    navigate('/my-assignments', {
      state: {
        workAssignmentId: assignmentId,
        status: 'Avbokad',
      },
    });
  };
  useEffect(() => {
    const assignmentId = assignmentIdHandler(location);
    if (assignmentId) {
      redirectToPath(assignmentId);
    }
  }, []);

  return assignmentIdHandler(location) ? (
    <div className="mx-auto mt-5 text-center">
      Email link redirect to Order Uppdrag och förfrågningar otherwise
      <div className="tv-buttons--download-wrapper tv-display-flex mt-5 ">
        <a
          href="https://apps.apple.com/us/app/itunes-connect/id376771144"
          className="tv-buttons--download-ios mr-5"
          rel="noreferrer"
          target="_blank"
        >
          <img
            className="tv-buttons--download-button"
            src="https://tfvstorage.blob.core.windows.net/images/iOS-download.svg"
            alt="iOS-download"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=se.tolkformedlingvast.tolkapp"
          className="tv-buttons--download-android"
          rel="noreferrer"
          target="_blank"
        >
          <img
            className="tv-buttons--download-button"
            src="https://tfvstorage.blob.core.windows.net/images/google-play-badge.svg"
            alt="Android-download"
          />
        </a>
      </div>
    </div>
  ) : (
    <p className="mx-auto mt-5 text-center">
      Email redirect link broken. Kindly apologize for the inconvenience.
      <br />
      <b> Please contact TFV</b>
    </p>
  );
}

export default EmailRedirect;
